import { useState } from "react";
import { Box, Grid } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import AntigenList from "./AntigenList";
import VaccineProductList from "./VaccineProductList";
import ScheduleList from "./ScheduleList";
import ContraindicationList from "./ContraindicationList";
import RiskCohortList from "./RiskCohortList";
import VaccinePresentationList from "./VaccinePresentationList";
import AdministrationRouteList from "./AdministrationRouteList";
import AdministrationSiteList from "./AdministrationSiteList";
import FundingSourceList from "./FundingSourceList";
import VaccinationOutcomeReasonList from "./VaccinationOutcomeReasonList";
import CoverageMetricList from "./CoverageMetricList";

const TABS = [
  { key: "antigen", label: "Antigens", Component: AntigenList },
  { key: "product", label: "Vaccine Products", Component: VaccineProductList },
  { key: "schedule", label: "Schedules", Component: ScheduleList },
  {
    key: "contraindication",
    label: "Contraindications",
    Component: ContraindicationList,
  },
  { key: "riskCohort", label: "Risk Cohorts", Component: RiskCohortList },
  {
    key: "presentation",
    label: "Presentations",
    Component: VaccinePresentationList,
  },
  {
    key: "route",
    label: "Routes",
    Component: AdministrationRouteList,
  },
  { key: "site", label: "Sites", Component: AdministrationSiteList },
  {
    key: "fundingSource",
    label: "Funding Sources",
    Component: FundingSourceList,
  },
  {
    key: "outcomeReason",
    label: "Outcome Reasons",
    Component: VaccinationOutcomeReasonList,
  },
  {
    key: "coverageMetric",
    label: "Coverage Metrics",
    Component: CoverageMetricList,
  },
];

const ImmunizationMasters = () => {
  const [activeTab, setActiveTab] = useState("antigen");
  const { searchText } = useOutletContext() || {};

  const Active =
    TABS.find((tab) => tab.key === activeTab)?.Component || AntigenList;

  return (
    <Grid container alignItems="center">
      <Grid item sm={12} md={12} lg={12} padding={2}>
        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
          {TABS.map((tab) => (
            <Box
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              sx={{
                borderBottom:
                  activeTab === tab.key ?
                    "2px solid #194AF5"
                  : "2px solid transparent",
                color: activeTab === tab.key ? "#194AF5" : "#7D8DC4",
                width: "max-content",
                padding: "0.5rem 1rem",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              {tab.label}
            </Box>
          ))}
        </Box>

        <Active searchText={searchText || ""} />
      </Grid>
    </Grid>
  );
};

export default ImmunizationMasters;
